import axios from "axios";
import {
  FETCH_REGTYPES,
  CREATE_REGTYPE,
  UPDATE_REGTYPE,
  DELETE_REGTYPE,
  UPDATE_DEFAULT_REGTYPE,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);

export function createRegType(rt) {
  return {
    type: CREATE_REGTYPE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/registration_type/`, rt, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchRegTypes() {
  return {
    type: FETCH_REGTYPES,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/registration_type/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateDefault(rt) {
  return {
    type: UPDATE_DEFAULT_REGTYPE,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/registration_type/default/${rt.id}`,
      rt,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function clear() {
  return {
    type: 'CLEAR_REGTYPE',
    payload: null
  };
}

export function getEditable(edited) {
  return {
    type: UPDATE_REGTYPE,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/registration_type/${edited.id}`,
      edited,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function getDeletable(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_REGTYPE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/registration_type/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
